import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ProgramCard({ program, index = 0 }) {
  return (
    <Link
      to={`/programs/${program.slug}`}
      data-testid={`program-card-${program.slug}`}
      className="group card-lux relative overflow-hidden block"
    >
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={program.image}
          alt={program.name}
          className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
          loading={index < 3 ? "eager" : "lazy"}
        />
        <div className="absolute inset-0 cinema-overlay" />
        <div className="absolute top-5 left-5 flex items-center gap-2">
          <span className="overline text-[10px] px-3 py-1 rounded-full glass border-white/20">
            {program.level}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-7">
          <div className="flex justify-between items-end gap-4">
            <div>
              <div className="overline text-[10px] text-[color:var(--wk-gold)]">
                {program.duration} · {program.investment}
              </div>
              <div className="mt-3 font-serif-display text-3xl md:text-4xl leading-none">
                {program.name}
              </div>
              <p className="mt-3 text-[color:var(--wk-bone-dim)] max-w-md text-sm leading-relaxed">
                {program.tagline}
              </p>
            </div>
            <span className="w-11 h-11 rounded-full hairline flex items-center justify-center text-[color:var(--wk-gold)] group-hover:bg-[color:var(--wk-gold)] group-hover:text-black transition-all shrink-0">
              <ArrowUpRight size={18} />
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
